import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4 overflow-hidden" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "p-4" }
const _hoisted_4 = { style: {"left":"0","right":"0","bottom":"-41px","position":"absolute","margin-left":"-12px","margin-right":"-10px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4\"><h3 class=\"mb-0\">Courses Sales</h3><select class=\"form-select month-select form-control p-0 h-auto border-0 w-90\" style=\"background-position:right 0 center;\" aria-label=\"Default select example\"><option selected>This Month</option><option value=\"1\">UI/UX</option><option value=\"2\">Wordpress</option></select></div><div class=\"stats-box pt-4 position-relative\" style=\"height:232px;\"><div class=\"d-flex flex-wrap gap-2 align-items-center\"><h3 class=\"fs-20 mb-0 me-4\">$57.2k</h3><span class=\"count up fw-medium ms-0\">+10%</span></div></div>", 2)),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.isClient)
            ? (_openBlock(), _createBlock(_component_apexchart, {
                key: 0,
                type: "area",
                height: "280",
                options: _ctx.coursesSales,
                series: _ctx.sales
              }, null, 8, ["options", "series"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}